package com.jingfangpai.prescription.model

import com.jingfangpai.common.orm.mapping.Prescription
import com.jingfangpai.common.orm.mapping.enums.PrescriptionSubCategory
import kotlinx.serialization.Serializable

@Serializable
class PrescriptionDetail: Prescription() {
    var categoryOthers: Map<PrescriptionSubCategory, List<Prescription>> = emptyMap()
}
